export default {
  AddReviewButtonLabel: 'Add Review',
  NoReviews: 'No Reviews',
  Verified: 'Verified',
  AddReview: {
    ReviewerName: 'Reviewer Name',
    ReviewerNamePlaceholder: 'Enter the name of the reviewer',
    Relationship: 'Relationship Title',
    RelationshipPlaceholder: 'Enter the caregiver-reviewer relationship',
    Date: 'Date of Review',
    Rating: 'Rating',
    VerifiedReview: 'Verified Review',
    Text: 'Review Text',
    TextPlaceholder: 'Enter the review here...',
    Cancel: 'Cancel',
    Save: 'Save',
    SaveError: 'Something went wrong',
  },
};
